import baseService from './baseService';

export const getCompanyProfile = (id) => baseService.get(`/company_profiles/${id}`);
